import { useEffect, useState } from 'react'
import { Skeleton } from '@chakra-ui/react'

import { Salary } from 'InstitutionalManagement/types'
import SalaryCard from 'InstitutionalManagement/components/SalaryCard'
import { useCustomFormAnswer } from 'components/tools/CustomForm/components/Answers/contexts/CustomFormViewerQuestionManager/Provider'
import getSalaryOnCustomForm from './services/getSalaryOnCustomForm'

export default function CustomFormAnswerSalary() {
  const [loadingSalary, setLoadingSalary] = useState<boolean>(false)
  const [salary, setSalary] = useState<Salary>({})

  const { answer } = useCustomFormAnswer()

  const answerValue = answer.answer ? answer.answer[0] : ''

  const salaryId: string = answerValue

  async function getSalary() {
    setLoadingSalary(true)
    const response = await getSalaryOnCustomForm({ salaryId })
    if (response?.header?.success) {
      const salaryFromAPI = response?.body?.salary
      setSalary(salaryFromAPI)
    }
    setLoadingSalary(false)
  }

  useEffect(() => {
    if (answerValue) getSalary()
  }, [answerValue])

  return (
    <Skeleton isLoaded={!loadingSalary}>
      <SalaryCard borderWidth="1px" borderColor="borderColor" salary={salary} />
    </Skeleton>
  )
}
